import { useQuery } from '@tanstack/react-query';
import { AREA_PARAMETER_NAME } from 'constants/gcConstants';
import { G_AREA_UNITS_QUERY_KEY } from 'constants/queryKeys';
import { GUnit } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';
import { useFetchGParameters } from './useFetchGParameters';

export const useFetchGAreaUnits = (gOrgId: string | null) => {
  const { data: parameters } = useFetchGParameters();

  const areaParameterId =
    parameters?.find((p) => p.name === AREA_PARAMETER_NAME)?.id ?? null;

  return useQuery<GUnit[]>({
    queryKey: [G_AREA_UNITS_QUERY_KEY, gOrgId, areaParameterId],
    queryFn: () =>
      GlobalCatalogueService.FetchGUnitParameterById(gOrgId!, areaParameterId!),
    enabled: !!gOrgId && !!areaParameterId,
    staleTime: 1000 * 60 * 5,
  });
};
